
import Index from '~/pages/franchise-directory/industries/_industry/_company/index'
export default Index
